import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGitlabColor16 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#E24329",
			d: "m14.767 6.597-.02-.05-1.905-4.973a.5.5 0 0 0-.493-.313.5.5 0 0 0-.287.108.5.5 0 0 0-.169.256l-1.286 3.937h-5.21L4.11 1.625a.5.5 0 0 0-.948-.052l-1.91 4.97-.018.051a3.54 3.54 0 0 0 1.173 4.09l.007.005.017.012 2.903 2.174 1.436 1.087.875.66a.59.59 0 0 0 .711 0l.875-.66 1.436-1.087 2.92-2.187.008-.006a3.54 3.54 0 0 0 1.172-4.085"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FC6D26",
			d: "m14.767 6.597-.02-.05a6.4 6.4 0 0 0-2.562 1.151L8 10.863l2.666 2.015 2.92-2.187.007-.006a3.54 3.54 0 0 0 1.174-4.088"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FCA326",
			d: "m5.334 12.878 1.436 1.087.875.66a.59.59 0 0 0 .711 0l.875-.66 1.436-1.087S9.425 11.938 8 10.863c-1.425 1.075-2.666 2.015-2.666 2.015"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FC6D26",
			d: "M3.814 7.698a6.4 6.4 0 0 0-2.561-1.154l-.02.05a3.54 3.54 0 0 0 1.174 4.09l.007.005.017.012 2.903 2.174L8 10.86z"
		})
	]
});
const ForwardRef = forwardRef(SvgIconGitlabColor16);
export default ForwardRef;
